import { findStep } from './stepUtils';

import { OnboardingStatus } from '@cobliteam/common-types';

import { Step, type UserOnboarding, type UserOnboardingStep } from '@cobliteam/api-lib';

import type { OnboardingStep } from '../store/slices/onboardingSteps';
import useOnboardingStore from '../store/useOnboardingStore';

const useUpdateOnboardingStore = () => {
  const setOnboardingShowSidebar = useOnboardingStore((state) => state.setOnboardingShowSidebar);
  const setOnboardingStatus = useOnboardingStore((state) => state.setOnboardingStatus);
  const setWelcomeModal = useOnboardingStore((state) => state.setWelcomeModal);
  const setOnboardingStepsIndex = useOnboardingStore((state) => state.setOnboardingStepsIndex);
  const setOnboardingStepsTotal = useOnboardingStore((state) => state.setOnboardingStepsTotal);
  const setOnboardingSteps = useOnboardingStore((state) => state.setOnboardingSteps);
  const setHasOnboarding = useOnboardingStore((state) => state.setHasOnboarding);
  const onboardingSteps = useOnboardingStore((state) => state.onboardingSteps);

  const setOnboardingStore = (updatedOnboarding?: UserOnboarding) => {
    if (updatedOnboarding) {
      setHasOnboarding(true);
      if (updatedOnboarding.createdAt && !updatedOnboarding.startedAt) {
        setOnboardingStatus(OnboardingStatus.INITIAL);
        setWelcomeModal(true);
      } else if (updatedOnboarding.startedAt && !updatedOnboarding.endedAt) {
        setOnboardingStatus(OnboardingStatus.IN_PROGRESS);
        setWelcomeModal(false);
      } else if (updatedOnboarding.startedAt && updatedOnboarding.endedAt) {
        setOnboardingStatus(OnboardingStatus.COMPLETED);
        setWelcomeModal(false);
      }

      if (updatedOnboarding.dismissedAt) {
        setOnboardingShowSidebar(false);
      }

      const index = updatedOnboarding.steps.filter((step) => step.endedAt !== null || step.skippedAt !== null).length;

      setOnboardingStepsIndex(index);
      setOnboardingStepsTotal(updatedOnboarding.steps.length);
    } else {
      setHasOnboarding(false);
    }
  };

  const setOnboardingStepsStore = (steps?: UserOnboardingStep[]) => {
    if (steps) {
      const alertConfigStep = findStep(Step.ALERT_CONFIG, steps);
      const driversStep = findStep(Step.REGISTER_DRIVER, steps);
      const installDevicesStep = findStep(Step.INSTALL_DEVICE, steps);
      const monitoringStep = findStep(Step.REGISTER_GEOFENCE, steps);
      const understoodStep = findStep(Step.UNDERSTOOD, steps);
      const userSettingsStep = findStep(Step.INVITE_USER, steps);
      const vehicleStep = findStep(Step.ASSOCIATE_VEHICLE, steps);

      setOnboardingSteps([alertConfigStep, driversStep, installDevicesStep, monitoringStep, understoodStep, userSettingsStep, vehicleStep]);
    }
  };

  const getOnboardingStepStore = (step: Step): OnboardingStep | undefined => {
    return onboardingSteps.find((onboardingStep) => onboardingStep?.stepName === step);
  };

  return {
    setOnboardingStore,
    setOnboardingStepsStore,
    getOnboardingStepStore,
  };
};

export default useUpdateOnboardingStore;
